import { Card, CardMedia, CardContent, Typography, CardActions, Button } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { useAuthService } from "../../../../use-cases/auth"
import { IdProdutoImgMap } from "../../../assets/helpers/moduleProducts"
import { useUIService } from "../../../../use-cases/ui"
import { LegacyProductsList } from "../../../assets/helpers/ProdutosEnum"

export const ModuleCard = (props: {
  Nome: string,
  IdProduto: number
}) => {
  const navigate = useNavigate()
  // Service
  const { insertAcesso } = useAuthService()
  const { setLoading } = useUIService()

  const isLegacyProduct = LegacyProductsList.includes(Number(props.IdProduto))

  return <>
    <div
      style={{
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      <Card sx={{ width: 345, maxWidth: '100%' }}>
        <CardMedia
          sx={{ height: 140 }}
          image={IdProdutoImgMap.find((img) => img.id === props.IdProduto)?.img || ''}
          title={`${props.Nome} logo`}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            {
              props.Nome.toUpperCase()
            }
          </Typography>
        </CardContent>
        <CardActions>
          <Button
            onClick={async () => {
              const loadingId = `module-access-${props.IdProduto}-${Date.now()}`
              try {
                setLoading({
                  loading: true,
                  message: isLegacyProduct 
                    ? `Redirecionando para ${props.Nome}...` 
                    : `Acessando ${props.Nome}...`,
                  id: loadingId
                })

                const redirectUrl = await insertAcesso(props.IdProduto)
                
                if (isLegacyProduct && redirectUrl) {
                  // Redirecionar para URL externa do produto legado
                  window.location.href = redirectUrl
                } else {
                  // Navegar internamente para produtos modernos (dash_veles, etc)
                  setLoading({
                    loading: false,
                    id: loadingId
                  })
                  const internalUrl = IdProdutoImgMap.find((img) => img.id === props.IdProduto)?.url
                  if (internalUrl) {
                    navigate(internalUrl)
                  } else {
                    navigate('/modulos')
                  }
                }
              } catch (error) {
                setLoading({
                  loading: false,
                  id: loadingId
                })
                console.error('Erro ao acessar módulo:', error)
              }
            }}
            size="small"
          >
            Acessar
          </Button>
        </CardActions>
      </Card>
    </div>
  </>
}
